var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-wrapper"},[_c('img',{staticClass:"logo",attrs:{"alt":"denode logo","src":_vm.logo}}),_c('span',[_vm._v("DefimeLabs")])])}
var staticRenderFns = []

export { render, staticRenderFns }